import { DynamicObjectInterface } from '../../sdk/type';
import { FAIcon, IconStyle, Theme } from '../../ui/components';
import { GetColumnsType } from '../../ui/components/TableContainer/types/propsTypes';
import { getCampaignProgressStatus, UTCToCustomFormat } from '../../ui/utils';

export const getParticipationHistoryConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
  isAdmin: boolean = false,
) => {
  return [
    {
      key: 'campaignName',
      text: translation(isAdmin ? 'admin.userSetup.campaignName' : 'dashboard.profile.table.column.campaignName'),
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => <span>{object.campaignName}</span>,
    },
    {
      key: 'enrollmentDate',
      text: translation(isAdmin ? 'admin.userSetup.joinDate' : 'dashboard.profile.table.column.joinDate'),
      sortable: true,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{UTCToCustomFormat(object.enrollmentDate, 'MMMM D, YYYY')}</span>
      ),
    },
    {
      key: 'progressStatus',
      text: translation(isAdmin ? 'admin.userSetup.status' : 'dashboard.profile.table.column.status'),
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => (
        <span>{getCampaignProgressStatus(translation, object.progressStatus)}</span>
      ),
    },
    {
      key: 'actions',
      width: 30,
      text: '',
      render: (object: DynamicObjectInterface) => (
        <div
          className={`${styles['icon-container']} ${object.progressStatus !== 'Completed' || object.certificateRequired === 0 ? styles['inactive'] : ''}`}
        >
          <FAIcon
            onMouseOver={() => {}}
            iconName={'eye'}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.certificateRequired === 1) {
                cb?.onView({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={translation(
              isAdmin ? 'admin.userSetup.viewCertificate' : 'dashboard.profile.table.column.viewCertificate',
            )}
          />
          <FAIcon
            iconName={'download'}
            iconStyle={IconStyle.SOLID}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.certificateRequired === 1) {
                cb?.onDownload({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={translation(
              isAdmin ? 'admin.userSetup.downloadCertificate' : 'dashboard.profile.table.column.downloadCertificate',
            )}
          />
          <FAIcon
            iconName={'share-alt'}
            iconStyle={IconStyle.SOLID}
            onClick={e => {
              if (object.code && object.progressStatus === 'Completed' && object.certificateRequired === 1) {
                cb?.onShare({ teamId: object.teamId, campaignId: object.campaignId, code: object.code });
                e.stopPropagation();
              }
            }}
            theme={Theme.BLACK}
            title={translation(
              isAdmin ? 'admin.userSetup.shareCertificate' : 'dashboard.profile.table.column.shareCertificate',
            )}
          />
        </div>
      ),
    },
  ];
};
